import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Capacitor } from '@capacitor/core';

export default function AuthGuard() {
  const firebaseUser = useAuthStore((s) => s.firebaseUser);
  const initialized = useAuthStore((s) => s.initialized);
  const user = useAuthStore((s) => s.user);

  // Wait until auth is fully resolved (firebaseUser known AND user profile loaded or confirmed absent)
  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ backgroundColor: '#0a0a0f' }}>
        <div className="animate-pulse text-lg text-white">Loading...</div>
      </div>
    );
  }

  // Firebase user exists but profile not yet loaded — wait
  if (firebaseUser && !user) {
    return (
      <div className="flex h-screen items-center justify-center" style={{ backgroundColor: '#0a0a0f' }}>
        <div className="animate-pulse text-lg text-white">Loading...</div>
      </div>
    );
  }

  if (!firebaseUser) {
    return <Navigate to={Capacitor.isNativePlatform() ? '/login' : '/'} replace />;
  }

  // Email verification check: email/password users must verify their email
  // Skip for guests, Google sign-in (already verified), and anonymous users
  if (
    user &&
    !user.isGuest &&
    !firebaseUser.emailVerified &&
    firebaseUser.providerData.some((p) => p.providerId === 'password')
  ) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
